import axios from 'axios'
import router from '../router'

import {Toast} from 'vant';

const $http = axios.create({
  baseURL: '/api',
  timeout: 10000
})

$http.interceptors.request.use(
  config => {
    let token = window.sessionStorage.getItem('token');
    if (token && token != 'null') {
      config.headers.token = token;
      return config;
    }
    let ticket = window.sessionStorage.getItem("ticket");
    if (ticket && ticket != 'null') {
      config.headers.ticket = window.sessionStorage.getItem("ticket");
      config.headers.service = window.sessionStorage.getItem("serviceUrl");
      return config;
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
);
//响应拦截器
$http.interceptors.response.use(function (response) {
  if (response && response.data && response.data.code != '0000' && response.data.msg) {
    if (response.data.code == '1005') {
      Toast.fail(response.data.msg)
      router.push({
        path: "/",
      });
    }
    if (response.data.code == '1007') {
      router.push({
        path: "/",
      });
    }
    return response;
  }
  return response;
}, function (error) {
  console.log('err' + error)
  Toast.fail(error.message)
  return Promise.reject(error);
});

export default $http



// WEBPACK FOOTER //
// ./src/api/index.js